export const getCode = () => new URLSearchParams(window.location.search).get('code');
